"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _themeProvider = require("@mmc/theme-provider");

var _labelLike = _interopRequireDefault(require("./label-like"));

var _select = _interopRequireDefault(require("./select.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Select = function Select(_ref) {
  var id = _ref.id,
      testID = _ref['data-testid'],
      name = _ref.name,
      className = _ref.className,
      _onChange = _ref.onChange,
      light = _ref.light,
      label = _ref.label,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      options = _ref.options;
  var theme = (0, _themeProvider.useTheme)();

  var _useState = (0, _react.useState)(defaultValue),
      selectedValue = _useState[0],
      setSelectedValue = _useState[1];

  (0, _react.useEffect)(function () {
    setSelectedValue(defaultValue);
  }, [defaultValue]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_labelLike["default"], {
    htmlFor: id || name,
    light: light
  }, label), /*#__PURE__*/_react["default"].createElement("select", {
    id: name,
    "data-testid": testID,
    className: (0, _clsx["default"])(theme.customSelect, _select["default"].select, className),
    name: name,
    value: selectedValue,
    onChange: function onChange(e) {
      return _onChange(e);
    },
    "aria-label": label
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })));
};

var _default = Select;
exports["default"] = _default;